export default __webpack_public_path__ + "static/youtube-78c224a74001e44a96c7c14b9410354f.png";